import axios from 'axios'

const config = {
  baseURL: '',
  timeout: 60000,
  withCredentials: true,
}

const instance = axios.create(config)

export default instance
